import Vue, { CreateElement, VNode } from 'vue'
import VueApollo from 'vue-apollo'
import { configure as configureArvo } from '@padlet/arvo'
import * as errorTracker from 'bits/error_tracker'
import fixMobileViewport from 'bits/fix_mobile_viewport'
import { trackPrinting } from 'surface/printing'
import { watchHash } from 'surface/location'
import { observeConnectivity } from 'bits/connectivity'
import SurfaceApp from 'vuecomponents/surface_app.vue'
import { apolloProvider } from 'bits/apollo'
import store, { blankState } from 'surface/xstore/index'
import { RootState } from 'surface/xstore/types'
import initialState from 'surface/xstore/initial_state'
import window, { ww } from 'bits/global'
import connectStoreToPostMessage from 'bits/connect_store_to_post_message'
import { install as installNativeBridge } from 'native_bridge/install'
import { setTimezoneCookie } from 'bits/timezone'
import { connectRealtime } from 'bits/realtime'

setTimezoneCookie()

// Configure Arvo
// Technically, configureArvo returns a Promise which should
// be awaited.
const { constants: { arvoConfig } } = ww.vueStartingState
configureArvo(arvoConfig)

const startingState: RootState = {
  ...blankState(),
  ...initialState(),
  ...ww.vueStartingState,
}
store.dispatch('initializeState', startingState)
Vue.use(VueApollo)

errorTracker.init({
  vue: Vue,
  environment: store.state.environment,
  userId: store.state.user.id,
  locale: store.state.locale,
  release: store.state.release,
})

connectRealtime({
  user: store.state.user,
  wall: store.state.wall,
  environment: store.state.environment,
  deviceId: store.state.deviceId,
})

document.addEventListener('DOMContentLoaded', (): void => {
  // Mobile browsers handle 100% height in ways we don't like. Fix that.
  fixMobileViewport()

  // Track when user tries to print document using Ctrl+P
  trackPrinting()

  // Perform actions based on location hash, e.g. open panels
  watchHash()

  // Inform state when the browser goes offline/online
  observeConnectivity((isOnline: boolean): void => {
    store.dispatch('changeConnectivity', { isOnline })
  })

  // listen for postMessage calls
  connectStoreToPostMessage(store)

  // install older native brige methods in the window object
  installNativeBridge(window, store)

  Vue.config.devtools = process.env.NODE_ENV !== 'production'
  Vue.config.performance = process.env.NODE_ENV !== 'production'
  Vue.config.ignoredElements = ['trix-editor']

  // VueJS components
  window.app = new Vue({
    el: '#app',
    apolloProvider,
    store,
    render: (h: CreateElement): VNode => h(SurfaceApp),
  })
})
